import { render } from "./FloatingAlert.vue?vue&type=template&id=4c7a4caa&scoped=true"
import script from "./FloatingAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingAlert.vue?vue&type=script&setup=true&lang=js"

import "./FloatingAlert.vue?vue&type=style&index=0&id=4c7a4caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7a4caa"],['__file',"src/common/widgets/FloatingAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c7a4caa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c7a4caa', __exports__)) {
    api.reload('4c7a4caa', __exports__)
  }
  
  module.hot.accept("./FloatingAlert.vue?vue&type=template&id=4c7a4caa&scoped=true", () => {
    api.rerender('4c7a4caa', render)
  })

}


export default __exports__